<template>
  <div class="card">
    <div class="card-header">
      <div class="icon"><img :src="titleIcon" alt="" /></div>
      <p class="title">{{ title }}</p>
      <div class="content-status" v-if="status === $t('预接待')">
        {{ status }}
      </div>
      <div class="content-approval" v-if="status === $t('审批中')">
        {{ status }}
      </div>
      <div
        class="content-cancel"
        v-if="status === $t('已取消') || status === $t('已拒绝')"
      >
        {{ '已取消' }}
      </div>
      <div class="content-done" v-if="status === $t('已完成')">
        {{ status }}
      </div>
      <div v-if="buttonTitle" class="button" @click="onButtonClick">
        {{ buttonTitle }}
      </div>
    </div>
    <div class="card-body">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import titleIcon from '@/assets/images/title-icon.svg'
export default {
  name: 'Card',
  props: {
    title: String,
    buttonTitle: String,
    status: String,
  },
  data() {
    return {
      titleIcon,
    }
  },
  methods: {
    onButtonClick() {
      this.$emit('button-click')
    },
  },
}
</script>

<style lang="less" scoped>
.card {
  width: 351px;
  height: auto;
  min-height: 100px;
  background: #ffffff;
  border-radius: 8px;
  padding-bottom: 4px;

  .card-header {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 48px;
    border-bottom: 1px solid #eaecef;

    .button {
      position: absolute;
      right: 11px;
      width: 126px;
      height: 32px;
      background: #ffffff;
      border-radius: 20px;
      border: 1px solid #3972ff;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #3972ff;
      line-height: 32px;
      text-align: center;
      font-style: normal;
    }

    .title {
      font-size: 16px;
      color: #1e2329;
      line-height: 24px;
      text-align: left;
      font-family: PingFangSC, PingFang SC;
      font-style: normal;
    }

    .icon {
      width: 4px;
      height: 16px;
      margin-left: 12px;
      margin-right: 8px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .content-status {
    flex-shrink: 0;
    padding: 0 4px;
    height: 18px;
    background: #e1f7e9;
    border-radius: 2px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #1bb579;
    line-height: 18px;
    text-align: center;
    font-style: normal;
    margin-left: 8px;
  }

  .content-cancel {
    flex-shrink: 0;
    padding: 0 4px;
    height: 18px;
    background: #eaecef;
    border-radius: 2px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #707a8a;
    line-height: 18px;
    text-align: center;
    font-style: normal;
    margin-left: 8px;
  }

  .content-done {
    flex-shrink: 0;
    padding: 0 4px;
    height: 18px;
    background: #dff2ff;
    border-radius: 2px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #3972ff;
    line-height: 18px;
    text-align: center;
    font-style: normal;
    margin-left: 8px;
  }

  .content-approval {
    flex-shrink: 0;
    padding: 0 4px;
    height: 18px;
    background: rgba(234, 170, 92, 0.2);
    border-radius: 2px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #ffb459;
    line-height: 18px;
    text-align: center;
    font-style: normal;
    margin-left: 8px;
  }
}

.card-body {}
</style>
